import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle2" }, "Share Post (Optional)", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Sharing with:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_users_list = _resolveComponent("users-list")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Escalate Post",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        label: "Escalate",
        color: "warning",
        task: _ctx.task,
        id: "escalate-post-btn",
        onClick: _ctx.escalate
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_q_input, {
          modelValue: _ctx.keyword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
          placeholder: "Search by name or email",
          autocomplete: "no",
          debounce: "750",
          clearable: "",
          "clear-icon": "fa fa-times",
          dense: "",
          filled: ""
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "fa fa-search",
              size: "xs",
              color: "primary"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_users_list, {
          "account-id": _ctx.post.client.customerId,
          keyword: _ctx.keyword,
          selected: _ctx.recipients,
          "exclude-self": "",
          onSelection: _cache[1] || (_cache[1] = ($event: any) => (_ctx.recipients = $event))
        }, null, 8, ["account-id", "keyword", "selected"]),
        _withDirectives(_createElementVNode("p", null, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.sharingWith), 1)
        ], 512), [
          [_vShow, _ctx.recipients.length]
        ]),
        _withDirectives(_createVNode(_component_q_input, {
          label: "Message (Optional)",
          placeholder: "E.g. Hey, please check this post out.",
          type: "textarea",
          modelValue: _ctx.message,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.message) = $event)),
          outlined: ""
        }, null, 8, ["modelValue"]), [
          [_vShow, _ctx.recipients.length]
        ])
      ])
    ]),
    _: 1
  }, 512))
}